import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import styles from "./commentComp.module.css";
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import GitHub from '@material-ui/icons/GitHub';
import Twitter from '@material-ui/icons/Twitter';


export const CommentComp = ({ item }) => {
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const [liked, setLiked] = useState(false);
    const history = useHistory();
    const url = process.env.REACT_APP_url;

    const getDate = (val) => {
        let joined = val.slice(0, 10).split("-").reverse();
        let month;
        switch (joined[1]) {
            case "01": month = "January";
                break;
            case "02": month= "February";
                break;
            case "03": month = "March";
                break;
            case "04": month= "April";
                break;
            case "05": month = "May";
                break;
            case "06": month= "June";
                break;
            case "07": month = "July";
                break;
            case "08": month= "August";
                break;
            case "09": month = "Sep";
                break;
            case "10": month= "Oct";
                break;
            case "11": month = "November";
                break;
            case "12": month= "December";
                break;
            default: month = "October";
                break;
        }
        let str = `${month} ${joined[0]}, ${joined[2]}`;
        return str;
    }
    useEffect(() => {
        axios.get(`${url}/likes/liked/comment/${item._id}/author/${loggedInUser._id}`)
            .then((res) => {
                setLiked(res.data.liked);
            })
            .catch((err) => {
                alert(err);
            })
    }, []);
    const handleLike = () => {
        if (!loggedIn) {
            history.push("/login");
            return;
        }
        const config = {
            comment: item._id,
            author: loggedInUser._id
        }
        axios.post(`${url}/likes/comment`, config)
        .then((res) => {
            console.log(res.data.like);
        })
        .catch((err) => {
            alert(err);
        })
        setLiked(true);
    }
    const handleUnlike = () => {
        axios.delete(`${url}/likes/comment/${item._id}/author/${loggedInUser._id}`)
        .then((res) => {
            console.log(res.data.like);
        })
        .catch((err) => {
            alert(err);
        })
        setLiked(false);
    }
    return (
        <div className={styles.eachComment}>
            <div style={{display:"flex", justifyContent:"space-between"}}>
                <div style={{display:"flex"}}>
                <img src={item.author.profile_pic} alt="profile" />
                <div>
                    <div style={{display:"flex", alignItems:"center"}}>
                        <h3 style={{fontSize:"17px", color:"#302e2e"}}>{item.author.name}</h3>
                        <GitHub style={{marginLeft:"8px", color:"#6b6a6a"}} fontSize="small" />
                        <Twitter style={{marginLeft:"8px", color:"#6b6a6a"}} fontSize="small"/>
                        </div>
                    <p className={styles.tagSubDiv}>{item.author.tagline}</p>
                    </div>
                    </div>
                
                <div style={{ marginLeft: "280px", fontSize:"15px" }}>{ getDate(item.createdAt)}</div>
            </div>
            <p className={styles.commentBody}>{item.body}</p>
            <div className={styles.commentLikeBtn} style={{display:"flex", marginLeft:"49px"}}>
                {!liked ? <ThumbUpAltOutlinedIcon className={styles.commentIcon1} onClick={handleLike} fontSize="small" /> : <ThumbUpIcon className={styles.commentIcon2} onClick={handleUnlike} fontSize="small" />}
                <div style={{marginLeft:"5px"}}>{item.likes}</div>
            </div>
        </div>
    )
}





// if (likeRef.current) {
//             axios.post("${url}/likes/post", config)
//                 .then((res) => {
//                     console.log(res.data.like);
//                 })
//                 .catch((err) => {
//                     alert(err);
//                 })
//         } else {
//             axios.delete(`${url}/likes/post/${id}/author/${loggedInUser._id}`)
//                 .then((res) => {
//                     console.log(res.data.like);
//                 })
//                 .catch((err) => {
//                     alert(err);
//                 })
//         }